import { Route, Routes } from "react-router-dom";
import Test from '../test/test2'


const Test_rou = () => {
    return <>
    <Test/>
    </>
}

export default Test_rou;